import { GraphType } from "@services/monitoring/types";

export const typeTooltip: Partial<Record<GraphType, string>> = {
  [GraphType.Jitter_Audio]: "Audio Jitter",
  [GraphType.Jitter_Video]: "Video Jitter",
  [GraphType.Jitter_Content]: "Content Jitter",
  [GraphType.Call_Rate]: "Video Bitrate",
  [GraphType.Bit_Rate_Content]: "Content Bitrate",
  [GraphType.Packet_Loss]: "Video Packet Loss",
  [GraphType.Packet_Loss_Percentage_Content]: "Content Packet Loss",
  [GraphType.Frame_Rate]: "Video Speed",
  [GraphType.Frame_Rate_Content]: "Content Speed",
};

export const toggleTypeSets = [
    [GraphType.Call_Rate, GraphType.Bit_Rate_Content],
    [GraphType.Jitter_Audio, GraphType.Jitter_Video, GraphType.Jitter_Content],
    [GraphType.Packet_Loss, GraphType.Packet_Loss_Percentage_Content],
    [GraphType.Frame_Rate, GraphType.Frame_Rate_Content],
  ];
